import { LicenseScope } from '@platform-frontend/marketplace';
import { GotoAction, SimpleRouterNavigationExtras } from '@platform-frontend/util';
import { RefreshAcademicRegistrationMessageParams } from '../flow';
import { AcademicRegistrationData } from './model/academic-registration-data';
import { StudentDetails } from './model/student-details';

export class SetAcademicRegistration {
  static readonly type = '[Academic] Set academic registration';
  constructor(public academicRegistration: AcademicRegistrationData) {}
}

export class SetLicenseScope {
  static readonly type = '[Academic] Set license scope';
  constructor(public licenseScope: LicenseScope) {}
}

export class SetStudentDetails {
  static readonly type = '[Academic] Set student details';
  constructor(public studentDetails: StudentDetails) {}
}

export class SetAcademicWebsite {
  static readonly type = '[Academic] Set academic website';
  constructor(public website: string) {}
}

export class SetIpRange {
  static readonly type = '[Academic] Set ip range';
  constructor(public ipRange: string[]) {}
}

export class StartAcademicVerification {
  static readonly type = '[Academic] Start academic verification';
}

export class CheckAcademicVerification {
  static readonly type = '[Academic] Check academic verification';
  constructor(public timeoutInMilliseconds: number) {}
}

export class ResendAcademicVerification {
  static readonly type = '[Academic] Resend academic verification';
}

export class CompleteAcademicVerification {
  static readonly type = '[Academic] Complete academic verification';
}

export class CancelAcademicVerification {
  static readonly type = '[Academic] Cancel academic verification';
}

export class GotoAcademicRegistration extends GotoAction {
  static readonly type = '[Academic] Goto academic registration';
  constructor(public startParams: RefreshAcademicRegistrationMessageParams, public extras?: SimpleRouterNavigationExtras) {
    super(extras);
  }
}
